import React, { FC, useState, useEffect } from 'react';
import axios from 'axios';

import { useUser } from '../../lib/hooks/user';


type Props = {
    onClick(): void;
};


export const Header: FC<Props> = ({ onClick }) => {
    const [unread, setUnread] = useState(false);
    const [unpaid, setUnpaid] = useState(false);
    const user = useUser();
    const isAppAccess = window.navigator.userAgent === 'Salon.jp App/iOS';

    useEffect(() => {
        async function initialize() {
            if (user.id) {
                const { data: { newIds } } = await axios.get('/notifications/show');
                setUnread(newIds.length > 0);
                const { data: { countUnpaids } } = await axios.get('/notifications/unpaid');
                setUnpaid(countUnpaids > 0);
            }
        };
        initialize();
    }, []);

    return (
        <header>
            <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&amp;display=swap" />
            <link rel="stylesheet" href="/css/header.css?v=3.72" />
            <div className="gnavOuter for-salon">
                <div className="gnavInner">
                    <div className="gNavLeft">
                        <a className="main-title" href="/nishino">
                            <span className="sub-title sp">会員数国内最大級オンラインサロン</span>
                            <div className="logo-and-title">
                                <img
                                    className="small"
                                    src="/img/nishino/logo.png"
                                    alt="サロンJP"
                                />
                                <span className="title">西野亮廣エンタメ研究所</span>
                            </div>
                        </a>
                    </div>
                    <div className="gNavRight">
                        <div className="main-menu">
                            <a href="/nishino">
                                <img className="menu-icon" src="/img/home.png" />
                                <span className="menu-text">ホーム</span>
                            </a>
                            <a href="/articles">
                                <img className="menu-icon" src="/img/article.png" />
                                <span className="menu-text">サロン記事</span>
                            </a>
                            <a href="/present_projects">
                                <img className="menu-icon" src="/img/present.png" />
                                <span className="menu-text">プレゼント</span>
                            </a>
                            <a href="/coupon_list">
                                <img className="menu-icon" src="/img/coupon.png" />
                                <span className="menu-text">クーポン</span>
                            </a>
                            <a href="/map">
                                <img className="menu-icon" src="/img/map2.png" />
                                <span className="menu-text">チムニーマップ</span>
                            </a>
                        </div>
                        {user.id ?
                            <>
                                <div className="gNavRight-user">
                                    <a href="/mypages">
                                        <img className="gNavRight-icon" src={user.facebookId ? `/user_icons/get/dummy?user_id=${user.id}` : `${user.icon_path}`} alt="プロフィール画像" />
                                    </a>
                                </div>
                                {unread && (
                                    <div className="gNavRight-bell">
                                        <a href="/mypages/redirectNotice">
                                            <img className="gNavRight-icon notify-bell" src="/img/icon_notification.png" alt="お知らせページリンク" />
                                            <div className="notify-badge"><span>●</span></div>
                                        </a>
                                    </div>
                                )}
                            </>
                            : <div>
                                <a href="/authentications/login?redirect=/map" className="login-btn">
                                    ログイン
                                </a>
                            </div>}
                        <button
                            type="button"
                            className="menu-button"
                            onClick={onClick}
                        >
                            <img
                                className="hamburger"
                                src="/img/btn_hamburger.png"
                                alt="ハンバーガーメニュー"
                            />
                        </button>
                    </div>
                </div>
            </div>

            <style jsx>{`
                header {
                    padding-top: 63px;
                }
                .header-inner {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .top-logo-image {
                    heght: 18px;
                    width: 126px;
                }
                h1 {
                    font-size: 13px;
                }
                .nav {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .menu-button {
                    cursor: pointer;
                    margin-left: 1rem;
                    outline: none;
                }
                p {
                    font-size: 14px;
                }
                button {
                    padding: 0;
                    border: none;
                    background: none;
                }
                a {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    text-decoration: none;
                    color: black;
                }
                .members-link {
                    font-size: 14px;
                    margin-left: 1.4rem;
                }
                .notifications-link {
                    position: relative;
                    width: 20px;
                    margin-left: 1.4rem;
                }
                .mypage-link {
                    background: #f6efec;
                    border-radius: 2rem;
                    padding: 7px 20px 7px 20px;
                    font-size: 14px;
                    margin-left: 1.8rem;
                }
                .login-link {
                    font-size 14px;
                    margin-left: 1.8rem;
                }
                .notifications-image {
                    width: 20px;
                    animation: 1s both notify-bell-rotation;
                    animation-delay: 1s;
                }
                .notify-badge > span {
                    display: block;
                    font-size: 26px;
                }
                .profile-image {
                    border-radius: 50%;
                }
                @keyframes notify-bell-rotation {
                    0% {
                        transform: rotate(0);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
                .profile-image,
                .search-icon {
                    width: 22px;
                    height: 22px;
                    margin-right: 12px;
                }
                .login-btn {
                    background: #47392C;
                    border-radius: 4px;
                    color: #FFFFFF!important;
                    padding: 10px;
                    display: block;
                }
                .gnavOuter {
                    padding: 10px 20px;
                }
                .menu-icon {
                    width: 20px;
                    border-radius: 0;
                    margin-left: 10px;
                }
                .main-menu a:first-child .menu-icon {
                    margin-left: 0px;
                }
                .main-menu {
                    margin-left: 0 !important;
                    padding: 5px 15px;
                    border-left: solid 1px #000;
                    border-right: solid 1px #000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .main-menu > a {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .main-title {
                    line-height: 1;
                    margin-right: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .gnavOuter.for-salon .main-title {
                    flex-flow: column;
                    align-items: normal;
                }
                .main-title .small {
                    width: 30px;
                }
                .sub-title {
                    font-size: 10px;
                    letter-spacing: 1px;
                }
                .sub-title.pc {
                    margin-left: 10px;
                }
                .gnavOuter.for-salon .sub-title.pc {
                    display: none;
                }
                .sub-title.sp {
                    display: none;
                    font-size: 10px;
                    margin-bottom: 4px;
                }
                .gnavOuter.for-salon .sub-title.sp {
                    display: block;
                }
                .menu-text {
                    font-size: 10px;
                    margin-left: 3px;
                }
                .logo-and-title {
                    display: flex;
                    align-items: center;
                }
                header .title {
                    font-family: "Zen Kaku Gothic New", sans-serif;
                    font-weight: bold;
                    color: black;
                    letter-spacing: 1px;
                    display: block;
                }
                .logo-and-title > .title {
                    margin-left: 10px;
                }
                @media screen and (max-width: 980px) {
                    .gnavOuter {
                        padding: 10px 20px;
                    }
                    .main-menu {
                        padding: 5px 10px;
                    }
                    .menu-icon {
                        margin-left: 5px;
                    }
                    .sub-title.sp {
                        display: block;
                    }
                    .sub-title.pc {
                        display: none;
                    }
                    .main-title {
                        flex-flow: column;
                        align-items: normal;
                    }
                }
                @media screen and (max-width: 890px) {
                    .menu-text {
                        display: none;
                    }
                    .main-menu > a {
                        margin: 0 5px;
                    }
                }
                @media screen and (max-width: 768px) {
                    .sub-title.sp {
                        font-size: 10px;
                    }
                    .main-title .small {
                        width: 25px;
                    }
                }
                @media screen and (max-width: 580px) {
                    .main-menu {
                        display: none;
                    }
                }
                @media screen and (max-width: 540px) {
                    .top-logo-image {
                        heght: 16px;
                        width: 111px;
                    }
                    .mypage-link {
                        padding: 0;
                        margin-left: 1rem;
                    }
                    .members-link {
                        margin-left: 1rem;
                    }
                    .notifications-link {
                        margin-left: 1rem;
                    }
                    .login-link {
                        font-size 14px;
                        margin-left: 1.8rem;
                    }
                    .menu-button {
                        margin-left: 1.4rem;
                    }
                    .profile-image,
                    .search-icon {
                        margin: 0;
                    }
                    span {
                        display: none;
                    }
                }
            `}</style>
        </header>
    );
};
